export default function displayAmount(amount) {
    let currencyCode = document.querySelector(".calc-hidden-currency");

    if (currencyCode) {
        let textvalue = document.querySelector(".calc-hidden-currency").value;
        textvalue = textvalue.replace("###", amount.slice(amount.length - 3, 6));
        textvalue = textvalue.replace("#", amount.slice(0, amount.length - 3));

        // Split value of the hidden currency input field and select the third element in the array
        // This will be our currency
        var currency = document.querySelector(".calc-hidden-currency").value.split(" ")[2];

        // Add a period for every third character from the right to the amount
        var amount = amount.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");

        // Add both the amount and currency to a string ready to be placed in the html
        return textvalue;
    }
}